import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICreateOrder, IOrder } from "@shared/interfaces/orders.interface";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { JwtService } from "./jwt.service";

@Injectable()
export class OrdersService {

  private orders$ = new BehaviorSubject<IOrder[]>([]);

  constructor(private http: HttpClient, 
              private jwtService: JwtService) {}

  loadOrders(page = 1, count = 50) {
    let url = environment.apiUrl + `/user/orders?page=${page}&count=${count}`;
    return this.http.get(url);
  }

  get orders() {
    return this.orders$.value;
  }

  getOrders() {
    return this.orders$.asObservable();
  }
  
  getOrdersSync() {
    return this.orders;
  }
  
  setOrders(orders: IOrder[]) {
    this.orders$.next(orders);
  }

  addOrder(order: IOrder) {
    this.setOrders([
      order,
      ...this.orders
    ])
  }

  private get token() {
    return this.jwtService.getTocken() ?? '';
  }  

  get headers(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.token
    });
  }
  
  createOrder(body: ICreateOrder) {
    let fd = new FormData();
    Object.entries(body)
    .forEach(([key, value]) => {
      if(key == 'order_details'){
        let valueArray  = value as any[];
        for (let i = 0; i < valueArray.length; i++) {
          Object.entries(valueArray[i])
          .forEach(([innerKey, innerValue]) => {
            if(innerKey == 'files'){
              let fileIndex = 0;
              let fileArray  = innerValue as any[];
              fileArray.forEach(file => {
                fd.append(`order_details[${i}][files][${fileIndex}]`, file as File);
                fileIndex ++
              });
            } else {
              fd.append(`order_details[${i}][${innerKey}]`, innerValue as string);
            }
          })
        }
      } else {
        fd.append(key, value);
      }
    })
    let url = environment.apiUrl + '/user/orders';
    return this.http.post(url, fd, {
      headers: this.headers
    });
  }

}